import React, { FC } from 'react';

import classNames from 'classnames';
import getClassName from 'src/common/utils/getClassName';
import PriceTerm from '../../../common/components/PriceTerm';
import { Currency } from '../../../types/common/Currencies';
import s from './TermsAndCancellation.module.scss';
import { completePriceFormatter } from '../../../common/utils/currency';

type TermsAndCancellationProps = {
  currency: Currency;
  classNameModifier?: string;
  deposit: number;
  listingUrl?: string;
  cancellationPolicy?: string;
  withTooltips?: boolean;
  freeCancellationInMarketplace?: boolean;
};

const TermsAndCancellation: FC<TermsAndCancellationProps> = ({
  currency,
  deposit = 0,
  cancellationPolicy,
  listingUrl,
  classNameModifier,
  withTooltips = true,
  freeCancellationInMarketplace,
}) => {
  let description = 'Service fees are non-refundable.';

  if (freeCancellationInMarketplace && cancellationPolicy) {
    description = cancellationPolicy;
  }

  return (
    <ul className={getClassName(s, 'root', classNames(classNameModifier))}>
      {cancellationPolicy && (
        <li className={s.term}>
          <div className={s.termHeading}>Terms and Cancellation Policy</div>
          {description}
          {!freeCancellationInMarketplace && (
            <>
              <br />
              <PriceTerm tooltipContent={withTooltips && (
                <>
                  Please review
                  {' '}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={listingUrl}
                  >
                    the listing description
                  </a>
                  {' '}
                  for complete rental requirements and terms.
                </>
              )}
              >
                {cancellationPolicy}
              </PriceTerm>
            </>
          )}
        </li>
      )}
      {deposit > 0 && (
        <li className={s.term}>
          <div className={s.termHeading}>Security Allowance</div>
          <PriceTerm tooltipContent={withTooltips && (
            <>
              In case of minor expenses or damage,
              the listing owner may claim up to this amount
              as an additional charge.
              {' '}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://getmyboat.zendesk.com/hc/en-us/articles/115003922928-The-owner-has-filed-a-claim-under-the-incidental-coverage-limit-What-is-this-"
              >
                Find out more.
              </a>
            </>
          )}
          >
            {`${completePriceFormatter(
              deposit,
              currency?.code,
              currency?.symbol,
              currency?.precision,
            )} damage & incidentals.`}
          </PriceTerm>
        </li>
      )}
    </ul>
  );
};

export default TermsAndCancellation;
